/**
 * NEUTRAL-GAUGE-PREVIEW
 * Example of the gauge of a topic, with or without the neutral answers shown apart (display settings)
 */
import { connect } from "react-redux"
import { withTranslation, WithTranslation } from "react-i18next"
import { Session } from "@/redux/_session.types"
import getRepartitionColor from "@/utils/get-repartition-color.utils"

interface StateProps extends WithTranslation {
  _session: Session
}

interface OwnProps {
  isSeparated: boolean
}

type Props = StateProps & OwnProps

//Example of a topic : 18.2 % negative, 20.9 % neutral, 60.9 % positive, 8 % not concerned
const NEGATIVE = 18.2
const NEUTRAL = 20.9
const POSITIVE = 60.9
const NOT_CONCERNED = 8

function NeutralGaugePreview(props: Props) {
  const { t } = props
  const settings = props._session.dashboardDisplaySettings
  const red = getRepartitionColor(0, 1, false, settings, false)
  const green = getRepartitionColor(1, 1, false, settings, false)

  const segments: { color: string; ratio: number }[] = props.isSeparated
    ? [
        { color: red, ratio: NEGATIVE },
        { color: getRepartitionColor(1, 2, false, settings, false), ratio: NEUTRAL },
        { color: green, ratio: POSITIVE }
      ]
    : [
        { color: red, ratio: NEGATIVE },
        { color: green, ratio: NEUTRAL + POSITIVE }
      ]

  return (
    <div className="mt-2">
      <div className="grey-t text-sm">{t("account_neutral_separated_preview")}</div>

      <div className="mt-1 flex" style={{ width: 400 }}>
        <div className="details-topic-repartition flex" style={{ width: (100 - NOT_CONCERNED) * 3.75 }}>
          {segments.map((segment, i) => (
            <div
              key={i}
              className="details-topic-repartition-item"
              style={{ backgroundColor: segment.color, width: segment.ratio + "%" }}>
              {segment.ratio > 5 && <span>{segment.ratio.toFixed(1)} %</span>}
            </div>
          ))}
        </div>

        <div
          className="details-topic-repartition-item"
          style={{
            marginLeft: 6,
            backgroundColor: "#d5d4d4",
            width: NOT_CONCERNED * 3.75,
            height: 18,
            borderRadius: 8
          }}
        />
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  _session: state._session
})

export default connect(mapStateToProps)(withTranslation()(NeutralGaugePreview))
